import { httpClient } from '../utils/httpClient';
import { PeriodoPayload, PeriodoResponse } from '../types/periodo.types';

// ============================================================
// periodoService.ts
// httpClient extrae body.data y lanza Error(body.message)
// si success === false.
// ============================================================

export const periodoService = {

  async listar(): Promise<PeriodoResponse[]> {
    return httpClient.get<PeriodoResponse[]>('/periodos');
  },

  async listarPorAnioEscolar(anioEscolarId: number): Promise<PeriodoResponse[]> {
    return httpClient.get<PeriodoResponse[]>(`/periodos/anio-escolar/${anioEscolarId}`);
  },

  async obtener(id: number): Promise<PeriodoResponse> {
    return httpClient.get<PeriodoResponse>(`/periodos/${id}`);
  },

  async crear(payload: PeriodoPayload): Promise<PeriodoResponse> {
    return httpClient.post<PeriodoResponse>('/periodos', payload);
  },

  async modificar(id: number, payload: PeriodoPayload): Promise<PeriodoResponse> {
    return httpClient.put<PeriodoResponse>(`/periodos/${id}`, payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/periodos/${id}`);
  },
};
